export default "__VITE_ASSET__OD3F3IJP__"